// 发布项目模块
export default {
    PublishProject: {
        StartPublishing: 'Mula pernerbitan',
        ShareableQuestionnaire: 'Soal selidik boleh dikongsi selepas penerbitan',
        ProjectSharing: 'Kongsi Projek',
        LinkRemainsUnchanged: 'Pautan dan kod QR tidak akan berubah selepas pernerbitan',
        ShareLink: 'Kongsi pautan',
        Copy: 'Salin',
        Open: 'Buka',
        QRCode: 'Kod QR',
        DownloadQRCode: 'Muat turun Kod QR',
        WeChatSharing: 'Berkosing di Wechat',
        UploadLogo: 'Muat naik logo',
        ShareLogo: 'Kongsi logo',
        ClickToUpload: 'Klik untuk muat naik',
        ClickToDelete: 'Klik untuk padam',
        ImageSupport: 'Format gambar yang disokong:png、jpg, saiz 100*100',
        InputContent: 'Sila masukkan nama kenalan',
        ShareTitle: 'Kongsi topik',
        ShareDescriptionDescription: 'Kongsi penerangan',
        FriendSharingPreview: 'Pratonton perkongsian dengan rakan Wechat',
        ShareMomentPreview: 'Pratonton perkongsian di Detik Wechat',
        WeChatAvatar: 'Wechat Avatar',
        WeChatNickname: 'Gelaran Wechat',
        SMSSharing: 'Kongsi SMS',
        ViewSentTextMessages: 'Lihat teks mesej yang telah dihantar',
        AddRecipient: 'Tambah penerima',
        EditContent: 'Edit kandungan',
        Sent: 'Telah dihantar',
        BriefIntroduction: 'Anda boleh menambah penerima daripada senarai di sebelah kiri, atau memasukkan "nombor telefon, nama" secara manual, setiap baris mewakili satu penerima, dan nama penerima akan muncul dalam mesej teks. Contohnya: 136xxxxxxxxx, Encik ABC',
        ContactList: 'Senarai kenalan',
        Add: 'Tambah',
        ManuallyEnteringContacts: 'Masukkan kenalan secara manual',
        NumberOfRecipients: 'Nombor penerima',
        NextStep: 'Langkah seterusnya',
        InstructionsForUse: 'Perkara yang perlu diketahui：',
        InstructionsForUse1: '1.Kandungan SMS yang anda hantar perlu disemak',
        InstructionsForUse2: '2.Tajuk mesej teks akan dipaparkan sebagai [SurveyTree bagi pihak]',
        InstructionsForUse3: '3. Anda boleh menyemak status mesej teks selepas penhantaran telah berjaya',
        InstructionsForUse4: '4.$[name]mewakili name penerima $[surveylink] mewakili alamat pautan untuk soal selidik',
        InstructionsForUse5: '5. Penghantaran mesej teks ke nombor telefon bimbit yang tidak sah (termasuk nombor yang telah tamat penggunaan, nombor kosong, dll.) juga akan menyebabkan baki mesej teks atau baki akaun akan dipotong ',
        Back: 'Langkah sebelumnya',
        Sending: 'Sedang dihantar',
        SubmittedForSending: 'Telah diserahkan untuk menghantar.',
        SMSSent: 'SMS telah dihantar',
        SMSContent: 'Kandung SMS',
        NumberOfSenders: 'Nombor penghantar',
        SendingTime: 'Masa menghantar',
        State: 'Status',
        SMSDelivered: 'SMS telah disampaikan',
        SMSNotDelivered: 'SMS tidak dapat disampaikan',
        SMSDeliveryFailed: 'Penyampaias SMS gagal',
        Reason: 'Sebab',
        Operate: 'Operasi',
        ViewDetails: 'Semak butiran',
        BackSentSMSList: 'Kembali ke senarai mesej teks yang dihantar',
        PhoneNumber: 'Nombor telefon bimbit',
        Name: 'Nama',
        Success: 'Berjaya',
        Fail: 'Gagal',
        EmailSharing: 'Kongsi emel',
        ViewSharedEmails: 'Semak emel yang telah dikongsi',
        SelectSendingMethod: 'Pilih cara penghnataran',
        EmailContactDescription: 'Anda boleh menambah dalam kelompok daripada "Senarai Kenalan" di sebelah kiri, atau masukkan alamat emel penerima (atau "e-mel, nama") di sebelah kanan secara manual. Maksima tambahan sekali adalah 500.',
        InstructionsForUse: 'Penerangan penggunaan: “$[name]” mewakili nama penerima，“$[surveylink]” mewakili alamat puatan soal selidik ',
        Addresser: 'Penghantar',
        SenderEmail: 'Emel penghantar',
        Theme: 'Tema',
        SendViaEmail: 'Guna emel SurveyTree untuk menghantar',
        SendViaEmail1: 'Paparan emel soal selidik yang seragam:research@surveytree.org',
        SendViaEmail2: 'Setiap emel akan menggunakan satu kredit daripada baki emel, beli kredit emel dengan menambah nilai.',
        MailRemaining: 'Bake emel',
        RechargePurchase: 'Tambah nilai',
        SendUsingYourOwnEmail: 'Hantar dengan menggunakan emel peribadi anda',
        BindingRequired: 'Adalah perlu mengikat e-mel peribadi atau syarikat untuk memaparkan alamat emel keluar anda, meningkatkan imej jenama, tidak menggunakan baki e-mel dan mempunyai kadar kejayaan penghantaran yang lebih bagus.',
        LimitedToAdvancedVersionUse: 'Dihadkan kepada versi lanjutan',
        UpgradeNow: 'Meningkatkan segera',
        NotYetOpen: 'Masih below dibuka',
        SentMail: 'Emel yang telah dihantar',
        EmailSubject: 'Tajuk subjek emel',
        SendingMethod: 'Cara penghantaran',
        Undelivered: 'Today dapat disampaikan',
        Delivered: 'Telah disampaikan',
        DeliveryFailed: 'Penyampaian gagal',
        BackToTheListOfSentEmails: 'Kembali ke senarai emel yang dihantar',
        Mailbox: 'Peti emel',
        None: 'Tiada',
        SendConfirmation: 'Hantar pengesahan',
        ContentContainsCharacters: 'Kandungan mengandungi aksara',
        NumberOfConsumptionItems: 'Baki SMS yang akan digunakan',
        NumberOfContactsToBeSent: 'Nombor kenalan yang akan dihantar',
        TotalConsumptionSMSBalance: 'Jumlah baki SMS yang tertinggal',
        SMSBalance: 'Baki SMS',
        Strip: 'bilangan',
        Recharge: 'Tambah nilai',
        ReturnToModification: 'Kembali ke pengubahsuaian',
        ModificationPrompt: 'Gesaan pengubahsuaian',
        AreYouSureToModifyThisQuestionnaire: 'Pastikah anda ingin mengubahsuai soalselidik ini? Semua kumpulan data akan dihentikan，pautan soal selidik akan ditutup!',
        Wildcard: '$[surveylink] mewakili pautan soal selidik, sila jangan padamkannya! Selepas pemadaman, penerima tidak akan dapat melihat soal selidik lagi. Klik OK untuk memasukkan semula $[surveylink]',
        QuestionControl: 'Kawalan Soalan',
        MyQuestionBank: 'Bank Soalan saya',
        ForExample: 'Contohnya',
        Recipient: 'Contohnya: SurveyTree',
        Investigate: 'Tinjauan soal selidik',
        TelephoneSurveys: 'Tinjauan telefon',
        Interview: 'Temu bual',
        SetUp: 'Tetapan',
        PleaseWaitAMoment: 'Sila tunggu sementar',
        InsufficientSMSBalance: 'Baki SMS tidak mencukupi, sila tambah nilai',
        SuccessfullySent: 'Penghantaran berjaya',
        NoContactsToSend: 'Anda tiada kenalan untuk menghantar',
        FillInTheEmailSubject: 'Isikan tajuk subjek emel!',
        InsufficientEmailBalance: 'Baki emel tidak mencukupi, sila tambah nilai!',
        SuccessfullyCopied: 'Penyalinan berjaya!',
	    AndaPastiInginMenerbitkan: 'Pastikah anda ingin menerbitkan',
        Penerbitan: 'Sedang diterbitkan, sila tunggu',
        BerjayaDiterbitkan: 'Pernerbitan berjaya!',
        TidakDiterbitkan: 'Pernerbitan telah dibatalkan',
        SetBerjaya: 'Tetapan berjaya',
        PadamSecaraKekal: 'Operasi ini akan memadamkan semua data secara kekal, pastikah anda ingin meneruskan?'

    },
  };